module.exports = {
    loading:'loading',
    logout:'Log Out',
    logoutDesc:'Are you sure you want to logout?',
    check:'Check',
    ansTitle1:'Your answer is correct',
    ansTitle2:'you received',
    ansTitle3:'Your answer is wrong',
    congratulations:'Congratulations!',
    otp:'otp',
    ladingpageTips:'(Free of charge from 10th May to 10th June)',
    ladingpageTips2:'For New Users only!',
    Daily:'Daily',
    dailyM:'149 Ks',
    Weekly:'3 Days',
    weeklyM:'599 Ks',
    Monthly:'Monthly',
    monthlyM:'1999 Ks',
    subscribeNow:'Subscribe',
    Copyright:'Copyright © WowBox 2023',
    CopySucceeded:'Copy succeeded',
    play:'choose me',
    myAccount:'Personal info',
    profile:'Profile',
    FAQs:'FAQs',
    TC:'T&C',
    FAQ:'FAQ',
    language:'Language',
    Submit:'Submit',
    change:'change',
    English:'English',
    showMore:'See More',
    Login:'Login',
    Logout:'Log out',
    getCode:'send OTP',
    phoneNumber:'PHONE NUMBER',
    enderNumber:'Enter phone number',
    Name:'username',
    address:'Address',
    phone:'Phone',
    Prize:'Prize',
    referral:'referral',
    winnerList:'Winner List',
    Date:'Date',
    Save:'Save',
    cancel:'cancel',
    Confirm:'Confirm',
    goBack:'go back',
    No:'No',
    OK:'OK',
    Yes:'Yes',
    UNSUBSCRIBE:'UNSUBSCRIBE',
    noMore:'No more',
    more:'More',
    des2:'Are you sure you want to unsubscribe?',
    boxes:'boxes',
    box:'box',
    referralTips1:"Invite a new user to get the rewards. 5 quizzes will reward after invitee successfully subscribed, and invitee will be rewarded with 10 quizzes.",
    memberGetMember:'member-get-member',
    referralTips2:'This is your referral ID',
    referralTips3:'This is your friends referral ID',
    Status:'Status',
    noFound:'Ooops! <br />Found no results!',
    cgtips1:'WIN GRAND PRIZE !!!',
    cgtips2:'Only 149ks/daily,<br />please click OK to subscribe.',
    cgtips2W:'Only 599ks/weekly,<br />please click OK to subscribe.',
    cgtips2M:'Only 1999ks/monthly,<br />please click OK to subscribe.',
    indexbutton1:'choose randomly',
    indexbutton2:'choose 9x times',
    indexbutton3:'buy more boxes',
    landFont1:'Enter a phone number',
    landFont2:'Select',
    landingFont:'Charging of subscription fee will happen from main balance.',
    optTips:'You have already subscribed, please click OK to get the login code',
    landingContent:'<div class="ac">ATOM generic Terms & Conditions</div><br />1.The service will be eligible to use for 365 days with daily/ weekly/ monthly installment fees based on the service typed you choose.<br /><br />2.The ATOM collected fees for the use of service usage frequency for a time (for example, non renewal or daily, and there is no charge) or installment billing method ( eg weekly /monthly charge based on 365 days of the service may be).<br /><br />3.If the ATOM’s partner (third party) would provide/ serve the trial period for their service, customer can enjoy the trial period till the expiry date. Then, we may charge based on your chosen service even after the trial period is expired. And you will get charged from your mobile balance for the daily/ weekly/ monthly service fees after the trial period is end.Confirm that access the service due to these Terms of Service fees apply for recognition and acceptance confirmation.<br /><br />4.By clicking subscription you are accepting the Terms and Condition of the Service used.',
  Invitation_Link:'This is your invitation link',
  Copy:'Copy',
  Invitation_Count:'Invitation Count',
  start:'start',
  BuyMore:'Buy More',
  buytitle:'Buy more questions',
  buytitle2:'Unlock More Questions',
  buyContent:'WANT TO KEEP THE CHALLENGE GOING? Buy questions with 99 ks in order to open the boxes to win prizes',
  enterOtp:'Enter OTP',
  enterOtpContent:'A one time password has been sent to your phone. Please enter it below to confirm your purchase.',
  ResendTips:'Didn’t receive it? ',
  ResendOTP:'Resend OTP',
  pleaseWait:'Please Wait...',
  buyBtn:'1 Question – 99 Ks',
  otpSms:'Your WowBox OTP is ',
  optSms2:". Do not share to anyone.",
  ques_left:"questions left:",
  re_sub_tip:'You have unsubscribed ?',
  subscribe:'subscribe',
  login_tip_2:'Enjoy 7-day free trial & Get 30 ATOM Star Pointson every renewal',
  sharePanelTitle:'Share with friends',
  sharePanelTips:'Choose a platform below and send your invite link directly.',
  shareMore:'More Options',
  claimRewardMessage:"You've got 30MB Data Gift Pack for successful Activation.",
  claimNow:'CLAIM NOW!',
  claimRewardSuccess:'30MB Data Gift Pack claimed successfully.',
  claimClose:'Close reward dialog',
  claimRewardListTitle:'Data Gift Pack',
  claimRewardExpiry:'Expires At',
  claimRewardAmount:'Data',
  claimRewardAction:'Claim',
  claimRewardEmpty:'No data gift packs available.',
  homeLetsCheck:"LET'S CHECK",
  homeQuestionsLeft:'Questions Left:',
  homeMoreQuestions:'More Questions',
  homeLuckyDescription:'Pick your Lucky Box and',
  homeAmazingRewards:'get Amazing Rewards.',
  homePick:'PICK',
  homeRandomPick:'RANDOM PICK',
  homeGiftBoxesLeft:'Gift Boxes Left:',
  homeViewAllPrizes:'View All Prizes',
  homeWinners:'Winners',
  homeProfile:'Profile',
  homeLuckyBoxes:'Lucky Boxes',
  homeLuckyAvailable:'Lucky Box Available!!',
  homeTabNavigation:'Home navigation',
  prizesTitle:'PRIZES',
  prizesBack:'Back',
  prizesIntroBefore:'Open ',
  prizesLuckyBoxes:'Lucky Boxes',
  prizesIntroMiddle:' to get the following ',
  prizesRewards:'Rewards.',
  prizesCash300000:'CASH 300,000KS',
  prizesGoldRing:'GOLD RING',
  prizesSmartPhone:'SMART PHONE',
  prizesCash100000:'CASH 100,000KS',
  prizesTopUp20000:'TOP UP 20,000KS',
  prizesTopUp10000:'TOP UP 10,000KS',
  prizesData500MB:'DATA 500 MB',
  prizesData100MB:'DATA 100 MB',
  prizesData50MB:'DATA 50 MB',
  prizesData3GB:'DATA 3 GB',
  prizesData1GB:'DATA 1 GB',
  profileDefaultName:'PLAYER',
  profileSelectLanguage:'SELECT LANGUAGE',
  profileEnglish:'English',
  profileMyanmar:'Myanmar',
  profileSelected:'Selected',
  profileConfirmTitle:'Confirm unsubscribe',
  profileEditName:'Edit nickname',
  profileNamePlaceholder:'Enter your nickname',
  profileNameRequired:'Please enter a nickname.',
  profileCancel:'Cancel',
  claimRewardNetworkError:'Could not claim the data gift. Please try again.',
  answerCorrectTitle:'CORRECT!',
  answerWrongTitle:'WRONG!',
  answerYourAnswerIs:'Your Answer is',
  answerCorrectWord:'Correct!',
  answerWrongWord:'Wrong!',
  answerYouGot:'You got',
  answerLuckyBoxes:'Lucky Boxes.',
  answerConfirmCorrect:'AWESOME!',
  answerConfirmWrong:'OKIE',
  answerClose:'Close answer result',
  prizeOpenBoxTitle:'OPEN BOX',
  prizeOpenedPrefix:'You have opened a',
  prizeLuckyBox:'Lucky Box!',
  prizeReceived:'You’ve received the following reward:',
  prizeThankYou:'Thank You',
  prizeOk:'OK',
  prizeClaimReward:'CLAIM REWARD',
  prizeClose:'Close prize result',
  winnerEmpty:'No winners yet',
  buyPopupTitle:'BUY QUESTIONS',
  buyPopupNeedMore:'Need more questions?',
  buyPopupGet:'Get',
  buyPopupExtraQuestions:'Extra questions',
  buyPopupAnd:'and',
  buyPopupKeepFun:'keep the fun going!',
  buyPopupPrice:'1 QUESTION - 99 KS',
  buyPopupClose:'Close buy questions dialog',
  buyOtpTitle:'ENTER OTP',
  buyOtpPleaseEnter:'Please enter the',
  buyOtpCode:'OTP',
  buyOtpCodeSuffix:'code',
  buyOtpContinue:'to continue.',
  buyOtpConfirm:'CONFIRM',
  helpFaqSection:'FREQUENTLY ASKED QUESTIONS',
  helpTermsSection:'TERMS & CONDITIONS',
  subscribeDailyPrice:'249 Ks',
  subscribeThreeDayPrice:'699 Ks',
  subscribeMonthlyPrice:'1999 Ks',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js